export const environments = {
  unknown: "unknown",
  development: "development",
  test: "test",
  qa: "qa",
  pac: "pac",
  pilot: "pilot",
  staging: "staging",
  perf: "perf",
  cit: "cit",
  prodops: "prodops",
  evals: "evals",
  preview: "preview",
  communal: "communal",
  circleCI: "circleCI",
  production: "production",
} as const;

export type Environment = (typeof environments)[keyof typeof environments];
